export const events = {
  viewInAppCommsComponent: 'View in app communications component',
  clickInAppCommsComponent: 'Click in app communications component',
  dismissInAppCommsComponent: 'Dismiss in app communications component',
}
